import React from 'react';
import { IconProps } from '../icons/icons';

/**
 * Archive icon SVG component
 */
export const Archive: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = '#000', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.6933 3.48667L12.7667 2.36667C12.5867 2.14 12.3133 2 12 2H4C3.68667 2 3.41333 2.14 3.22667 2.36667L2.30667 3.48667C2.11333 3.71333 2 4.01333 2 4.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V4.33333C14 4.01333 13.8867 3.71333 13.6933 3.48667ZM8 11.6667L4.33333 8H6.66667V6.66667H9.33333V8H11.6667L8 11.6667ZM3.41333 3.33333L3.95333 2.66667H11.9533L12.58 3.33333H3.41333Z'
      fill={color}
    />
  </svg>
);

export default Archive;
